require('../theme/index.less');

module.exports = require('./components/index');
